export default "__VITE_ASSET__eCkzyW9W__"